import styled, { css } from 'styled-components'

import { mobileMediaQuery } from '@subaio/webapp'

type Props = {
	hasConnections: boolean
}

export const ConnectWrapper = styled.div<Props>`
	max-width: ${({ hasConnections }) => (hasConnections ? 'unset' : '400px')};

	${mobileMediaQuery(css`
		max-width: unset;
	`)}
`
